// This model is used for saving the boot stock material to local storage while offline
export class BootStockLocalMaterialModel {
    public constructor(
        public materialNumber: string,
        public storageLocation: string,
        public quantity: number,
    ) {}
}

export interface BootStockLocalMaterialModelJson {
    materialNumber: string;
    storageLocation: string;
    quantity: number;
}
